export default __webpack_public_path__ + "static/media/1.683a15c9.jpg";